import { useContext } from '@/components/slider-type/context';
import { useAppSelector } from '@/redux/store';
import { selectAnswersDefaultByKey, selectValidationByKey } from '@/redux/slider';
import { ConfigSlice } from '@/redux/config';
import '@/components/slider-type/components/error-message/error-message-v1.css';
import '@/components/slider-type/components/error-message/error-message-v2.css';

export default function ErrorMessage() {
  const { slide } = useContext();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const validation = useAppSelector(selectValidationByKey(slide.key));
  const answerDefault = useAppSelector(selectAnswersDefaultByKey(slide.key));

  const shouldShowError =
    validation.dirty && validation.messages.length > 0 && (validation.required || answerDefault !== '');

  if (!shouldShowError) return null;

  return (
    <div data-css-version={cssVersion} className='slider-type-error-message'>
      {validation.messages[0]}
    </div>
  );
}
